"use client";

import { QRCodeSVG } from "qrcode.react";

export function TotpQr({
  otpauthUrl,
  secret,
  scanHint,
  secretLabel,
}: {
  otpauthUrl: string;
  secret: string;
  scanHint: string;
  secretLabel: string;
}) {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">{scanHint}</p>
      <div className="flex justify-center rounded-lg border border-border bg-card p-4">
        <QRCodeSVG value={otpauthUrl} size={160} level="M" />
      </div>
      <div className="space-y-1">
        <p className="text-xs font-medium text-muted-foreground">{secretLabel}</p>
        <p className="break-all font-mono text-xs text-muted-foreground">{secret}</p>
      </div>
    </div>
  );
}
